import React, { useRef } from 'react';
import { Row, Col } from 'antd';
import Video from '../images/Sequence-02.mp4';
import startImg from '../images/Portal.png';

import '../App.css';

const Banner = ({ data }) => {
    const shopSectionRef = useRef(null);

    const scrollToShop = () => {
        shopSectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };
    return (
        <div>
            <section className="banner-one">
                <div className="container-fluid">
                    <Row
                        gutter={[40, 20]} // Adjust gutter for smaller screens
                        style={{ overflowX: 'hidden' }}
                        align="start"
                        justify="space-between"
                    >
                        <Col xs={24} sm={24} md={12} lg={13} xl={13}>
                            <div className="theme-banner-left">

                                <h2>{data?.title}</h2>
                                <p>{data?.paragraph}</p>
                                <a href='#montiter'>{data?.button}</a>
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={11} xl={11}>
                            <Row gutter={[10, 15]}>
                                <Col span={24}>
                                    <div className="atheme-banner">
                                        <video width="600" muted autoPlay loop>
                                            <source src={Video} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <div className="atheme-banner-1">
                                        <img src={startImg} class="img-fluid" alt="star-img" />
                                        <button type="button">100+ Products</button>
                                        <button type="button" className="btn-1">1k+ Happy Customers</button>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </section>
        </div>
    );
}

export default Banner;
